import React from 'react';
import { Container, Grid, Segment, Header, Message, Icon } from 'semantic-ui-react';

export const e404 = () => (
  <Container className="errorPage">
    <Grid rows={1} verticalAlign="middle">
      <Grid.Row>
        <Grid.Column>
          <style>
            {`
            body > div#root,
            body > div#root > div,
            body > div#root > div > div:not(.menu),
            body > div#root > div > div:not(.menu) ,
            body > div#root > div > div:not(.menu) > div.errorPage,
            body > div#root > div > div:not(.menu) > div.errorPage > div {
              margin-top: -7rem;
              height: 100%;
            }
          `}
          </style>
          <Segment basic padded="very" textAlign="center">
            <Icon name="warning sign" size="massive" inverted />
            <Header inverted size="huge">Erreur - Page introuvable</Header>
            <Header inverted size="tiny">Aucune page correspondant à cette adresse n'a pu être trouvée (404)</Header>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
);

export const es404 = () => (
  <Container className="errorPage">
    <Grid rows={1} verticalAlign="middle">
      <Grid.Row>
        <Grid.Column>
          <Segment basic padded="very" textAlign="center">
            <Icon name="warning sign" size="massive" />
            <Header size="huge">Erreur - Page introuvable</Header>
            <Header size="tiny">Aucune page correspondant à cette adresse n'a pu être trouvée (404)</Header>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
);

export const e500 = () => (
  <Message icon negative size="massive">
    <Icon name="warning sign" />
    Erreur 404 : Page introuvable
  </Message>
);



// WEBPACK FOOTER //
// ./src/screens/Errors.js